import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { getQuotations } from "../../../api/quotation";
import { brand } from "../../../context";
import { useApoAuth } from "../../../hooks";
import { QuotationRequestDesktopTable } from "./QuotationRequestDesktopTable";
import { QuotationRequestMobileTable } from "./QuotationRequestMobileTable";

export function Quotations() {
  const [token, setToken] = useState<string | null>(null);
  const { getIdTokenClaims, source_entity } = useApoAuth();

  // Get and set token
  useEffect(() => {
    getIdTokenClaims().then((data) => !!data && setToken(data.__raw));
  }, [getIdTokenClaims]);

  const { data } = useQuery({
    queryKey: ["myquotations", token],
    queryFn: () => getQuotations({ token: token as string, params: { source_entity } }),
    enabled: !!token,
    refetchOnWindowFocus: false,
  });
  const quotations = data?.data?.results ?? [];

  return (
    <div className="Card Quotations" data-brand={brand}>
      <div className="Card__header">
        <h5>My Quotations</h5>
      </div>
      <div className="Card__body Quotations__body">
        <QuotationRequestMobileTable quotations={quotations} />
        <QuotationRequestDesktopTable quotations={quotations} />
      </div>
    </div>
  );
}
